"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentTag = exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType["AirWaybill"] = "AirWaybill";
    DocumentType["AuthorityToMakeEntry"] = "AuthorityToMakeEntry";
    DocumentType["BillOfLading"] = "BillOfLading";
    DocumentType["CarrierInspectionReport"] = "CarrierInspectionReport";
    DocumentType["CarrierInvoice"] = "CarrierInvoice";
    DocumentType["CustomsRelease"] = "CustomsRelease";
    DocumentType["DeliveryOrder"] = "DeliveryOrder";
    DocumentType["DeliveryReceipt"] = "DeliveryReceipt";
    DocumentType["Other"] = "Other";
    DocumentType["PackingList"] = "PackingList";
    DocumentType["ProofOfDelivery"] = "ProofOfDelivery";
    DocumentType["RateConfirmation"] = "RateConfirmation";
    DocumentType["ReleaseReceipt"] = "ReleaseReceipt";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var DocumentTag;
(function (DocumentTag) {
    DocumentTag["Generated"] = "generated";
    DocumentTag["Image"] = "image";
})(DocumentTag = exports.DocumentTag || (exports.DocumentTag = {}));
//# sourceMappingURL=document.js.map